import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import './Header.css';

function Header({ onAuthClick }) {
  const { user, signOut } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  // Close menu on scroll
  useEffect(() => {
    if (menuOpen) {
      window.addEventListener('scroll', closeMenu);
      return () => window.removeEventListener('scroll', closeMenu);
    }
  }, [menuOpen, closeMenu]);

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container header-content">
        <a href="/" className="header-logo">
          <img src="/assets/logo.png" alt="DiabloDSP" />
        </a>

        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
          <a href="#products" onClick={handleNavClick}>Products</a>
          <a href="#modelling-agency" onClick={handleNavClick}>Services</a>
          <a href="#contact" onClick={handleNavClick}>Contact</a>
          {user ? (
            <div className="header-user">
              <span className="header-email">{user.email}</span>
              <button className="header-auth-btn header-signout" onClick={() => { signOut(); closeMenu(); }}>
                Sign Out
              </button>
            </div>
          ) : (
            <button className="header-auth-btn" onClick={() => { onAuthClick(); closeMenu(); }}>
              Sign In
            </button>
          )}
        </nav>
      </div>

      {menuOpen && <div className="menu-overlay" onClick={closeMenu} />}
    </header>
  );
}

export default Header;
